export default __webpack_public_path__ + "static/product10-08ecae9aa4d0cdfd5a28436585d504c5.jpg";